import React, { useEffect, useMemo, useRef } from "react";

export default function OtpInput({ length = 4, value, onChange }) {
  const refs = useRef([]);

  const digits = useMemo(() => {
    const v = String(value || "").replace(/\D/g, "").slice(0, length);
    return Array.from({ length }, (_, i) => v[i] || "");
  }, [value, length]);

  useEffect(() => {
    refs.current = refs.current.slice(0, length);
  }, [length]);

  const setAt = (idx, char) => {
    const arr = [...digits];
    arr[idx] = char;
    onChange(arr.join(""));
  };

  const inputClass =
    "h-11 w-11 rounded-[8px] border border-[#f2c6cc] bg-white text-center text-[16px] font-semibold text-slate-700  outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f7d7db]";

  return (
    <div className="flex items-center gap-6">
      {digits.map((d, idx) => (
        <input
          key={idx}
          ref={(el) => (refs.current[idx] = el)}
          className={inputClass}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={1}
          value={d}
          onChange={(e) => {
            const char = e.target.value.replace(/\D/g, "").slice(-1);
            setAt(idx, char);
            if (char && idx < length - 1) refs.current[idx + 1]?.focus();
          }}
          onKeyDown={(e) => {
            if (e.key === "Backspace") {
              if (digits[idx]) {
                setAt(idx, "");
              } else if (idx > 0) {
                refs.current[idx - 1]?.focus();
                setAt(idx - 1, "");
              }
            }
            if (e.key === "ArrowLeft" && idx > 0) refs.current[idx - 1]?.focus();
            if (e.key === "ArrowRight" && idx < length - 1) refs.current[idx + 1]?.focus();
          }}
          onPaste={(e) => {
            e.preventDefault();
            const paste = (e.clipboardData.getData("text") || "")
              .replace(/\D/g, "")
              .slice(0, length);
            onChange(paste);
            const nextIndex = Math.min(paste.length, length - 1);
            refs.current[nextIndex]?.focus();
          }}
        />
      ))}
    </div>
  );
}